import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const creditsyardSettings = defineIntegrationSettings({
  fields: { enabled: z.boolean() },
  secrets: { shopApiKey: z.string().trim().min(1, "Shop API key is required") },
  connectOnly: {},
  computed: {},
});
